(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gamble-cart"]) return;
  try {
    
(() => {
  const form = document.getElementById('GambleCart');
  if (!form) return;
  form.querySelectorAll('[data-gc-quantity-step]').forEach(button => {
    button.hidden = false;
    button.addEventListener('click', () => {
      const input = button.parentElement.querySelector('input');
      const value = parseInt(input.value, 10);
      input.value = Math.max(0, (Number.isFinite(value) ? value : 1) + Number(button.dataset.gcQuantityStep));
      input.dispatchEvent(new Event('change', {bubbles: true}));
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
